import { createComponentHealth } from '@shared/components/ComponentHealth';

export const [wrapWithMegaNavHealthProvider, useMegaNavHealth] = createComponentHealth('MegaNav');
